import { render, staticRenderFns } from "./Transactionlocked.vue?vue&type=template&id=d062b508&scoped=true"
import script from "./Transactionlocked.vue?vue&type=script&lang=js"
export * from "./Transactionlocked.vue?vue&type=script&lang=js"
import style0 from "./Transactionlocked.vue?vue&type=style&index=0&id=d062b508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d062b508",
  null
  
)

export default component.exports